import { Link } from "react-router-dom";
import { ArrowRight, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Logo } from "@/components/logo";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";

interface LandingNavProps {
  socialEnabled: boolean;
  landingBlogVisible: boolean;
}

export function LandingNav({ socialEnabled, landingBlogVisible }: LandingNavProps) {
  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-full items-center justify-between px-4">
        <Link to="/" aria-label="Inicio de RepasoGPC">
          <Logo textClassName="text-xl" />
        </Link>
        <div className="hidden items-center gap-7 lg:flex">
          <a href="#producto" className="text-sm text-muted-foreground hover:text-foreground">Producto</a>
          {socialEnabled && <a href="#competencia" className="text-sm text-muted-foreground hover:text-foreground">Competencia</a>}
          <a href="#fuentes" className="text-sm text-muted-foreground hover:text-foreground">Fuentes</a>
          <a href="#como-funciona" className="text-sm text-muted-foreground hover:text-foreground">Cómo funciona</a>
          <a href="#precios" className="text-sm text-muted-foreground hover:text-foreground">Precios</a>
          {landingBlogVisible && <a href="#blog" className="text-sm text-muted-foreground hover:text-foreground">Blog</a>}
        </div>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Link to="/auth" className="hidden sm:block">
            <Button variant="ghost">Iniciar sesión</Button>
          </Link>
          <a href="#precios" className="hidden sm:block">
            <Button>
              Ver planes
              <ArrowRight className="h-4 w-4" />
            </Button>
          </a>
          <Sheet>
            <SheetTrigger asChild>
              <Button size="icon" variant="ghost" className="lg:hidden" aria-label="Abrir menú">
                <Menu className="h-5 w-5" />
              </Button>
            </SheetTrigger>
            <SheetContent>
              <SheetHeader>
                <SheetTitle><Logo /></SheetTitle>
              </SheetHeader>
              <div className="mt-8 flex flex-col gap-5 text-lg">
                <SheetClose asChild><a href="#producto">Producto</a></SheetClose>
                {socialEnabled && <SheetClose asChild><a href="#competencia">Competencia</a></SheetClose>}
                <SheetClose asChild><a href="#fuentes">Fuentes</a></SheetClose>
                <SheetClose asChild><a href="#como-funciona">Cómo funciona</a></SheetClose>
                <SheetClose asChild><a href="#precios">Precios</a></SheetClose>
                <SheetClose asChild>
                  <Link to="/auth" className="w-full">
                    <Button className="w-full">Iniciar sesión</Button>
                  </Link>
                </SheetClose>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}
